module.exports = __webpack_public_path__ + "img/79c1f25.png";